import { SKETCH_HOST_ID } from "../constants.js";
import { getPrototypeDOMStore } from "./store.js";

export function initDOMObserver(doc: Document): () => void {
  const root = doc.getElementById(SKETCH_HOST_ID);
  
  if (!root) {
    console.error(`[initDOMObserver] #${SKETCH_HOST_ID} not found in document`);
    return () => undefined;
  }

  const store = getPrototypeDOMStore();
  const { addElement, removeElement, setVisible } = store.getState();

  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const pid = (entry.target as HTMLElement).dataset.pid;
      if (pid) setVisible(pid, entry.isIntersecting);
    }
  }, { threshold: 0 });

  function observeElement(el: Element): void {
    const pid = (el as HTMLElement).dataset.pid;
    if (!pid) return;
    addElement(pid, el);
    io.observe(el);
  }

  function unobserveElement(el: Element): void {
    const pid = (el as HTMLElement).dataset.pid;
    if (!pid) return;
    removeElement(pid);
    io.unobserve(el);
  }

  // Initial scan
  for (const el of root.querySelectorAll("[data-pid]")) {
    observeElement(el);
  }

  const mo = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches("[data-pid]")) observeElement(node);
        for (const el of node.querySelectorAll("[data-pid]")) {
          observeElement(el);
        }
      }
      for (const node of mutation.removedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches("[data-pid]")) unobserveElement(node);
        for (const el of node.querySelectorAll("[data-pid]")) {
          unobserveElement(el);
        }
      }
    }
  });

  mo.observe(root, { childList: true, subtree: true });

  return () => {
    mo.disconnect();
    io.disconnect();
    const { clear } = store.getState();
    clear();
    
  };
}

export function getBoundingRect(pid: string): DOMRect | null {
  const store = getPrototypeDOMStore();
  const entry = store.getState().elements.find((e) => e.pid === pid);
  if (!entry || !entry.visible) return null;
  return entry.element.getBoundingClientRect();
}
